








import Vue from 'vue'
import Axios from 'axios'
import { KeyDict } from '@/types'
import { FaceBookPage } from '@/types/teams'
import ClipLoader from '@/components/vue-spinner/ClipLoader.vue'

export default Vue.extend({
  name: 'AddFacebook',
  data: () => ({
    usertoken: '',
    pages: {} as KeyDict<FaceBookPage>
  }),
  computed: {
    activeTeam (): string {
      return this.$store.direct.state.team.activeTeam
    }
  },
  watch: {
    activeTeam (newVal) {
      if (newVal !== '') {
        this.getPages()
      }
    }
  },
  mounted () {
    this.usertoken = window.location.href.split('access_token=')[1].split('&')[0]
  },
  methods: {
    async getPages () {
      const url = `https://graph.facebook.com/v7.0/me?access_token=${this.usertoken}&fields=accounts&format=json`
      const response = await Axios.get(url)
      if (response.status === 200) {
        response.data.accounts.data.forEach(page => {
          this.$set(this.pages, page.id, {
            name: page.name,
            id: page.id,
            usertoken: this.usertoken
          })
        })
        await this.$store.direct.dispatch.team.addFacebookPages(this.pages)
        this.$router.push({ path: 'teamsettings' })
      }
    }
  },
  components: {
    'clip-loader': ClipLoader
  }
})
